import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPlacementMarginEmailModalType,
  IPlacementMarginEmailRecipientModal,
  IInitiatePlacementMarginPayPacketStatusTransition,
  IPlacementMarginPayPackageStatus,
  IPlacementMarginPayPackageStatusTransitionModalDetails,
  IPlacementMarginStatusOptions,
  IUpdatePlacementMarginPayPackageStatusPayload,
  PlacementMarginStatusTransitionModalType,
} from './placement-pay-package-status.model';

export const initialState: IPlacementMarginPayPackageStatus = {
  payPackageStatusTransitionModalDetails: { openModal: false, type: PlacementMarginStatusTransitionModalType.None },
  payPackageStatusOptions: [],
  recentStatusUpdatedScenarioId: 0,
  isEmailModalOpen: null,
  emailRecipients: null,
};

const initiatePlacementMarginPayPacketStatusTransition =
  createAction<IInitiatePlacementMarginPayPacketStatusTransition>(
    'INITIATE_PLACEMENT_MARGIN_PAY_PACKET_STATUS_TRANSITION',
  );

const updatePlacementMarginPayPackageStatus = createAction<IUpdatePlacementMarginPayPackageStatusPayload>(
  'UPDATE_PLACEMENT_MARGIN_PAY_PACKAGE_STATUS',
);

const getPlacementMarginEmailRecipientsList = createAction<{ placementId: number }>(
  'GET_PLACEMENT_MARGIN_EMAIL_RECIPIENTS_LIST',
);

const placementMarginPayPackageStatusSlice = createSlice({
  name: 'placementMarginPayPackageStatus',
  initialState,
  reducers: {
    setPayPackageStatusTransitionModalDetails(
      state,
      action: PayloadAction<IPlacementMarginPayPackageStatusTransitionModalDetails>,
    ) {
      state.payPackageStatusTransitionModalDetails = action.payload;
    },
    setPayPackageStatusOptions(state, action: PayloadAction<IPlacementMarginStatusOptions[]>) {
      state.payPackageStatusOptions = action.payload;
    },
    setRecentStatusUpdatedScenarioId(state, action: PayloadAction<number>) {
      state.recentStatusUpdatedScenarioId = action.payload;
    },
    setStatusUpdatedEmailModalOpen(state, action: PayloadAction<IPlacementMarginEmailModalType>) {
      state.isEmailModalOpen = action.payload;
    },
    setEmailRecipients(state, action: PayloadAction<IPlacementMarginEmailRecipientModal>) {
      state.emailRecipients = action.payload;
    },
    reset() {
      return {
        ...initialState,
      };
    },
  },
});

const { actions } = placementMarginPayPackageStatusSlice;

export const { name: placementMarginPayPackageStatusSliceKey, reducer: placementMarginPayPackageStatusSliceReducer } =
  placementMarginPayPackageStatusSlice;

export const placementMarginPayPackageStatusActions = {
  ...actions,
  initiatePlacementMarginPayPacketStatusTransition: initiatePlacementMarginPayPacketStatusTransition,
  updatePlacementMarginPayPackageStatus: updatePlacementMarginPayPackageStatus,
  getPlacementMarginEmailRecipientsList: getPlacementMarginEmailRecipientsList,
};
